import PageLayout from "../../../layouts/pageLayout/pageLayout";
import { useGetApplicantDetailsQuery } from "../../../hooks/api/useGetApplicantDetailsQuery";

const ApplicationStatus = () => {
  const { applicantDetails: user } = useGetApplicantDetailsQuery();
  const fullName = `${user?.firstName || ""} ${user?.lastName || ""}`.trim();
  return (
    <div>
      <PageLayout heading="Application Status">
        <p>Hello, {fullName}</p>
        <p>Program: {user?.programName}</p>
      </PageLayout>
    </div>
  );
};

export default ApplicationStatus;
